import { createResource, useResource } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';
import {
	RESOURCE_ASSETS_USER_PERMISSION,
	ASSETS_USER_PERMISSION_MAX_AGE,
	ASSETS_USER_PERMISSION_KEY,
	emptyAssetsPermissionResponse,
} from './common/constants.tsx';
import checkAssetsPermission from './services/check-assets-permission.tsx';
import type { AssetsPermissionResponse } from './common/types.tsx';

export const assetsUserPermissionResource = createResource<AssetsPermissionResponse>({
	type: RESOURCE_ASSETS_USER_PERMISSION,
	getKey: () => ASSETS_USER_PERMISSION_KEY,
	getData: async (): Promise<AssetsPermissionResponse> => {
		if (!fg('aurum-997-license-kill-switch')) {
			return emptyAssetsPermissionResponse;
		}

		try {
			return await checkAssetsPermission();
		} catch (error) {
			return emptyAssetsPermissionResponse;
		}
	},
	maxAge: ASSETS_USER_PERMISSION_MAX_AGE,
});

export const useAssetsUserPermission = (): AssetsPermissionResponse => {
	const { data } = useResource<AssetsPermissionResponse>(assetsUserPermissionResource);
	return data ?? emptyAssetsPermissionResponse;
};
